import _styled from '@emotion/styled/base';
import { Flex } from '../../Flex/index.js';
import { SIZE_TO_MARGIN_MAP } from './constants.js';

const VisualElementGroupWrapper = _styled(Flex, {
  target: "euq9rtc1"
})({
  name: "1011efe",
  styles: "isolation:isolate"
} );
const VisualElementWrapper = _styled(Flex, {
  shouldForwardProp: prop => prop !== 'size',
  target: "euq9rtc0"
})("&:not(:first-of-type){margin-inline-start:", ({
  size
}) => `-${SIZE_TO_MARGIN_MAP[size]}`, ";}");

export { VisualElementGroupWrapper, VisualElementWrapper };
